var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75V12.75",
    stroke: "#FC3037",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7088 3.75024L2.45878 18.0002C2.32735 18.2279 2.25805 18.4861 2.25781 18.7489C2.25758 19.0118 2.32643 19.2701 2.45745 19.498C2.58848 19.7258 2.77709 19.9153 3.00438 20.0473C3.23168 20.1793 3.48967 20.2493 3.75253 20.2502H20.2525C20.5154 20.2493 20.7734 20.1793 21.0007 20.0473C21.228 19.9153 21.4166 19.7258 21.5476 19.498C21.6786 19.2701 21.7475 19.0118 21.7472 18.7489C21.747 18.4861 21.6777 18.2279 21.5463 18.0002L13.2963 3.75024C13.1658 3.5223 12.9775 3.33287 12.7503 3.20113C12.5231 3.06938 12.2652 3 12.0025 3C11.7399 3 11.4819 3.06938 11.2548 3.20113C11.0276 3.33287 10.8392 3.5223 10.7088 3.75024V3.75024Z",
    stroke: "#FC3037",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "#FC3037"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLine);
export default __webpack_public_path__ + "static/media/Warning-line.1e56a1a1453184f192f846de15eea800.svg";
export { ForwardRef as ReactComponent };